export const APP_ROUTE_PATHS = {
  home: "/",
  auth: "/auth",
  dashboard: "/dashboard",
  projectManagement: "/project-management",
  projectBoards: "/project-boards",
  calculationsSuite: "/calculations-suite",
  workspace: "/workspace",
  companyProject: "/company/projects/:projectId",
  files: "/files",
  drawingReviews: "/drawing-reviews",
  quoteAnalyses: "/quote-analyses",
  admin: "/admin",
  settings: "/settings",
  onboarding: "/onboarding",
  billing: "/billing",
  billingSuccess: "/billing/success",
  billingCancel: "/billing/cancel",
  billingReturn: "/billing/return",
  companyInvite: "/company-invite/:token",
  projectInvite: "/project-invite/:inviteId",
  formulaReference: "/formula-reference",
  materialData: "/material-data",
  resources: "/resources",
  whatsNew: "/whats-new",
  about: "/about",
  jobs: "/jobs",
  savedJobs: "/saved-jobs",
  jobDetail: "/jobs/:jobId",
  processBuilder: "/process-builder",
  processBuilderDetail: "/process-builder/:jobId",
  tools: "/tools",
  fixtures: "/fixtures",
  machines: "/machines",
  setupSheets: "/setup-sheets",
  jobTravelers: "/job-travelers",
  inspection: "/inspection",
  firstArticleInspections: "/first-article-inspections",
  controlPlans: "/control-plans",
  shopBrain: "/shop-brain",
  capacityPlanner: "/capacity-planner",
  shopFloor: "/shop-floor",
  aiAssistant: "/ai-assistant",
  qrCodes: "/qr-codes",
  exports: "/exports",
  threeS: "/3s",
  trelloConnect: "/trello-connect",
  trelloEmbeddedApp: "/integrations/trello/app",
  calculator: "/calculator/:toolId",
  messages: "/messages",
  notifications: "/notifications",
  collaborativeProjects: "/collaborative-projects",
  personalProjects: "/personal-projects",
  featureRequest: "/request-custom-tool",
  platformFeatureRequests: "/platform-admin/feature-requests",
  ownerRequests: "/owner/requests",
  systemHealth: "/platform-admin/system-health",
  productAnalytics: "/platform-admin/analytics",
};

export const CORE_SMOKE_ROUTES = [
  APP_ROUTE_PATHS.home,
  APP_ROUTE_PATHS.auth,
  APP_ROUTE_PATHS.dashboard,
  APP_ROUTE_PATHS.projectManagement,
  APP_ROUTE_PATHS.projectBoards,
  APP_ROUTE_PATHS.calculationsSuite,
  APP_ROUTE_PATHS.workspace,
  APP_ROUTE_PATHS.companyProject,
  APP_ROUTE_PATHS.drawingReviews,
  APP_ROUTE_PATHS.quoteAnalyses,
  APP_ROUTE_PATHS.admin,
  APP_ROUTE_PATHS.jobs,
  APP_ROUTE_PATHS.savedJobs,
  APP_ROUTE_PATHS.jobDetail,
  APP_ROUTE_PATHS.calculator,
  APP_ROUTE_PATHS.notifications,
  APP_ROUTE_PATHS.billing,
  APP_ROUTE_PATHS.onboarding,
  APP_ROUTE_PATHS.billingSuccess,
  APP_ROUTE_PATHS.billingCancel,
  APP_ROUTE_PATHS.billingReturn,
  APP_ROUTE_PATHS.settings,
  APP_ROUTE_PATHS.files,
  APP_ROUTE_PATHS.processBuilder,
  APP_ROUTE_PATHS.processBuilderDetail,
  APP_ROUTE_PATHS.tools,
  APP_ROUTE_PATHS.fixtures,
  APP_ROUTE_PATHS.machines,
  APP_ROUTE_PATHS.setupSheets,
  APP_ROUTE_PATHS.jobTravelers,
  APP_ROUTE_PATHS.inspection,
  APP_ROUTE_PATHS.firstArticleInspections,
  APP_ROUTE_PATHS.controlPlans,
  APP_ROUTE_PATHS.shopBrain,
  APP_ROUTE_PATHS.capacityPlanner,
  APP_ROUTE_PATHS.shopFloor,
  APP_ROUTE_PATHS.aiAssistant,
  APP_ROUTE_PATHS.qrCodes,
  APP_ROUTE_PATHS.exports,
  APP_ROUTE_PATHS.threeS,
  APP_ROUTE_PATHS.trelloConnect,
  APP_ROUTE_PATHS.trelloEmbeddedApp,
  APP_ROUTE_PATHS.messages,
  APP_ROUTE_PATHS.collaborativeProjects,
  APP_ROUTE_PATHS.projectInvite,
  APP_ROUTE_PATHS.personalProjects,
  APP_ROUTE_PATHS.featureRequest,
  APP_ROUTE_PATHS.platformFeatureRequests,
  APP_ROUTE_PATHS.ownerRequests,
  APP_ROUTE_PATHS.systemHealth,
  APP_ROUTE_PATHS.productAnalytics,
  APP_ROUTE_PATHS.formulaReference,
  APP_ROUTE_PATHS.materialData,
  APP_ROUTE_PATHS.resources,
  APP_ROUTE_PATHS.whatsNew,
  APP_ROUTE_PATHS.about,
];

export const buildCalculatorRoute = (toolId = "") =>
  APP_ROUTE_PATHS.calculator.replace(":toolId", encodeURIComponent(String(toolId || "")));

export const buildJobRoute = (jobId = "") =>
  APP_ROUTE_PATHS.jobDetail.replace(":jobId", encodeURIComponent(String(jobId || "")));

export const buildCompanyInviteRoute = (token = "") =>
  APP_ROUTE_PATHS.companyInvite.replace(":token", encodeURIComponent(String(token || "")));

export const buildProjectInviteRoute = (inviteId = "") =>
  APP_ROUTE_PATHS.projectInvite.replace(":inviteId", encodeURIComponent(String(inviteId || "")));

export const buildProcessBuilderDetailRoute = (jobId = "") =>
  APP_ROUTE_PATHS.processBuilderDetail.replace(":jobId", encodeURIComponent(String(jobId || "")));

export const buildDashboardCategoryRoute = (categoryId = "") =>
  `${APP_ROUTE_PATHS.dashboard}?category=${encodeURIComponent(String(categoryId || ""))}`;

export const buildCalculationsSuiteCategoryRoute = (categoryId = "") =>
  `${APP_ROUTE_PATHS.calculationsSuite}?category=${encodeURIComponent(String(categoryId || ""))}`;

export const buildDashboardAnchorRoute = (anchor = "") =>
  anchor ? `${APP_ROUTE_PATHS.dashboard}#${encodeURIComponent(String(anchor))}` : APP_ROUTE_PATHS.dashboard;

export const buildFormulaReferenceSearchRoute = (search = "") =>
  `${APP_ROUTE_PATHS.formulaReference}?search=${encodeURIComponent(String(search || ""))}`;

export const buildMessageContextRoute = ({
  contextType = "",
  contextId = "",
  contextLabel = "",
} = {}) => {
  const params = new URLSearchParams();
  if (contextType) params.set("contextType", contextType);
  if (contextId) params.set("contextId", String(contextId));
  if (contextLabel) params.set("contextLabel", String(contextLabel));
  const query = params.toString();
  return query ? `${APP_ROUTE_PATHS.messages}?${query}` : APP_ROUTE_PATHS.messages;
};

export const buildMessageConversationRoute = (conversationId = "") =>
  buildRouteWithQuery(APP_ROUTE_PATHS.messages, { conversation: conversationId });

export const buildAIAssistantContextRoute = ({
  contextType = "",
  contextId = "",
  prompt = "",
} = {}) => {
  const params = new URLSearchParams();
  if (contextType) params.set("contextType", contextType);
  if (contextId) params.set("contextId", String(contextId));
  if (prompt) params.set("prompt", String(prompt));
  const query = params.toString();
  return query ? `${APP_ROUTE_PATHS.aiAssistant}?${query}` : APP_ROUTE_PATHS.aiAssistant;
};

export const buildRouteWithQuery = (baseRoute = APP_ROUTE_PATHS.workspace, queryValues = {}) => {
  const params = new URLSearchParams();
  Object.entries(queryValues).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== "") {
      params.set(key, String(value));
    }
  });
  const query = params.toString();
  return query ? `${baseRoute}?${query}` : baseRoute;
};

export const buildCompanyProjectRoute = (projectId = "") =>
  APP_ROUTE_PATHS.companyProject.replace(":projectId", encodeURIComponent(String(projectId || "")));

export const buildPersonalProjectRoute = (projectId = "") =>
  buildRouteWithQuery(APP_ROUTE_PATHS.personalProjects, { project: projectId });

export const buildRecordRoute = (baseRoute = APP_ROUTE_PATHS.workspace, recordId = "") =>
  buildRouteWithQuery(baseRoute, { record: recordId });

export const buildPlanScopedRoute = (baseRoute = APP_ROUTE_PATHS.workspace, planId = "") =>
  buildRouteWithQuery(baseRoute, { plan: planId });



